import { useState } from 'react';
import { Download, FileText, FileSpreadsheet } from 'lucide-react';
import DateNavigator from './DateNavigator';
import { CategoryKey, categoryLabels, Athlete } from './testingTypes';
import { exportToExcel, exportToPDF } from '../utils/reportExport';
import styles from './TestingTopBar.module.scss';

interface TestingTopBarProps {
  selectedCategory: CategoryKey;
  onCategoryChange: (category: CategoryKey) => void;
  mode: 'entry' | 'analytics';
  selectedDate: string;
  onDateChange: (date: string) => void;
  allApiResults: { id: string; athleteId: string; testId: string; date: string; value: number }[];
  athletes: Athlete[];
}

export default function TestingTopBar({
  selectedCategory,
  onCategoryChange,
  mode,
  selectedDate,
  onDateChange,
  allApiResults,
  athletes,
}: TestingTopBarProps) {
  const [isReportDropdownOpen, setIsReportDropdownOpen] = useState(false);

  return (
    <div className={styles.topBar}>
      <div className={styles.categoryPillsWrapper}>
        <div className={styles.categoryPills}>
          {(Object.keys(categoryLabels) as CategoryKey[]).map((category) => (
            <button
              key={category}
              onClick={() => onCategoryChange(category)}
              className={[styles.categoryPill, selectedCategory === category ? styles.categoryPillActive : ''].filter(Boolean).join(' ')}
            >
              <p className={[styles.categoryPillLabel, selectedCategory === category ? styles.categoryPillLabelActive : ''].filter(Boolean).join(' ')}>
                {categoryLabels[category]}
              </p>
            </button>
          ))}
        </div>
      </div>

      {mode === 'entry' ? (
        <DateNavigator selectedDate={selectedDate} onDateChange={onDateChange} />
      ) : (
        <div className={styles.downloadWrapper}>
          <button
            onClick={() => setIsReportDropdownOpen(!isReportDropdownOpen)}
            className={styles.downloadBtn}
          >
            <Download className={styles.downloadIcon} />
            <span>Scarica report</span>
          </button>

          {isReportDropdownOpen && (
            <>
              <div
                className={styles.dropdownOverlay}
                onClick={() => setIsReportDropdownOpen(false)}
              />
              <div className={styles.dropdownMenu}>
                <button
                  onClick={() => {
                    exportToExcel({
                      category: selectedCategory,
                      categoryLabel: categoryLabels[selectedCategory],
                      testResults: allApiResults,
                      athletes: athletes,
                    });
                    setIsReportDropdownOpen(false);
                  }}
                  className={styles.dropdownItem}
                >
                  <FileSpreadsheet className={styles.dropdownItemIcon} />
                  <span className={styles.dropdownItemLabel}>Scarica .xls</span>
                </button>
                <button
                  onClick={() => {
                    exportToPDF({
                      category: selectedCategory,
                      categoryLabel: categoryLabels[selectedCategory],
                      testResults: allApiResults,
                      athletes: athletes,
                    });
                    setIsReportDropdownOpen(false);
                  }}
                  className={styles.dropdownItem}
                >
                  <FileText className={styles.dropdownItemIcon} />
                  <span className={styles.dropdownItemLabel}>Scarica .pdf</span>
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
